import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Empires",
  "description": "",
  "published": "2006-05-26T00:00:00.000Z",
  "redirect_from": ["/blog/empires/swizec/412"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Haven't posted in quite a while, been busy and when you add a pinch of lazy to the mix you get some pretty powerful magic.`}</p>
    <p>{`In the past week I've discovered two very interesting and awesome things. One is browser based gaming, sure I've been told about it, but wow it's awesome once youa ctually try. `}<a parentName="p" {...{
        "href": "http://imperiaonline.org"
      }}>{`This`}</a>{` has got to be the best MMORPG I've ever played. It's got all the properties of a MMORPG, except perhaps for an active environment, but in the mean time it's lacking all of the bad properties. It doesn't eat up all of your time and it certainly doesn't glue you to the computer screen for hours on end. On top of that `}<a parentName="p" {...{
        "href": "http://imperiaonline.org"
      }}>{`Imperia Online`}</a>{` has very nice hand drawn images that are simply marvelous to look at.`}</p>
    <p>{`Another great discovery was `}<a parentName="p" {...{
        "href": "http://www.cartoontomb.de/english/death.php"
      }}>{`Death & Maiden`}</a>{` a very funny webcomic that speaks of Death being quite the interesting and complex character that is getting cheated by a mere girly. The first part was great, sadly it's finished already, and the second part is showing great promise, although it's made in a somewhat different naration style. So guess we'll see...`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      